import { render } from "./filters.vue?vue&type=template&id=365f4e50&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"

import "./filters.vue?vue&type=style&index=0&id=365f4e50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f4e50"]])

export default __exports__